import PropTypes from 'prop-types'
import { Checkbox } from '../../../../../../common/html/checkbox'
import { valByKeyWithDot } from '../../../../../../helpers/value'

const ItemCheckbox = ({
  title,
  isRequire,
  keySetting,
  setting,
  value,
  setValue,
  isI18n,
}) => {
  const checked = valByKeyWithDot(setting, keySetting, true) || []

  const onChange = (val) => {
    if (val) {
      setValue(`setting.${keySetting}`, [...checked, value])
    } else {
      if (checked.length > 1) {
        setValue(
          `setting.${keySetting}`,
          checked.filter((item) => item !== value),
        )
      }
    }
  }

  return (
    <Checkbox
      title={title}
      isI18n={isI18n}
      isCheckOnClickText
      style={{ paddingLeft: 6 }}
      allowChange={!isRequire}
      checked={isRequire || checked.includes(value)}
      onChange={onChange}
    />
  )
}

ItemCheckbox.propTypes = {
  title: PropTypes.string.isRequired,
  isRequire: PropTypes.bool,
  keySetting: PropTypes.string.isRequired,
  setting: PropTypes.object,
  value: PropTypes.any,
  setValue: PropTypes.func.isRequired,
  isI18n: PropTypes.bool,
}

ItemCheckbox.defaultProps = {
  isRequire: false,
}

export default ItemCheckbox
